import initialState from './state'
import mutations from './mutations'
import actions from './actions'

export default {
  state: initialState(),
  mutations,
  actions,
}
